module.exports = __webpack_public_path__ + "LatoLatin-HeavyItalic.69dcfb26df1a890c750b.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.woff
// module chunks = styles